import React from "react";
import ReactDOM from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./core/Core.css";
import LoadApp from "./LoadApp";
import "./i18n";
ReactDOM.render(<LoadApp />, document.getElementById("root"));
